/* oxlint-disable react/forbid-elements */
import * as React from 'react';

import * as styles from './styles.css';

export function Faq16() {
  return (
    <svg
      className={styles['container']}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm1 6V7H7v5h2Z"
        fill="currentColor"
      />
    </svg>
  );
}
